import React from 'react';

interface PaymentFormButtonsProps {
  isLoading: boolean;
  onClose: () => void;
  amount?: string | number;
  paymentType?: string;
  onSubmit: () => void;
}

export const PaymentFormButtons: React.FC<PaymentFormButtonsProps> = ({
  isLoading,
  onClose,
  amount,
  paymentType,
  onSubmit,
}) => {
  const isDisabled = isLoading || !amount || !paymentType;

  return (
    <div className="flex justify-start gap-3">
      <button
        type="button"
        disabled={isDisabled}
        onClick={onSubmit}
        className={`rounded-[8px] px-4 py-[12px] font-sans text-[16px] font-semibold ${
          isDisabled
            ? 'cursor-not-allowed bg-N100 text-text-primaryLight'
            : 'bg-R300 text-text-primary hover:bg-R400'
        }`}
      >
        {isLoading ? 'Creating...' : 'Create Payment'}
      </button>
      <button
        type="button"
        onClick={onClose}
        style={{
          backgroundColor: '#F3F4F5',
        }}
        className="rounded-[8px] px-4 py-2 font-sans text-[16px] font-semibold hover:bg-gray-200"
      >
        Cancel
      </button>
    </div>
  );
};
